import { Ref, useEffect, useMemo, useRef, useState } from 'react'
import KeepAlive from 'react-activation'
import { useLocation, useParams } from 'react-router-dom'
import { Button, FormInstance, Spin, message, Empty } from 'antd'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { getAuth } from '@/utils/btn.ts'

import {
  getOrderRelativesList,
  getTrackPlanRelativesList,
  orderRelativesUpdate,
  orderServicePersonnel,
  orderServicePersonnelUpdate,
} from '@/services/order'
import { useSetState } from 'ahooks'
import { isEmpty } from 'lodash-es'
import styles from './index.module.less'
import { getUser } from '@/common/utils'

const QuotaList = props => {
  const { detail } = props
  const params = useParams()
  const id = params?.id // 订单id
  const auths = getAuth() || {}
  const formRef = useRef<
    Ref<any> & {
      onFormRef: () => FormInstance
    }
  >(null)
  const user = getUser()

  const submitFormValueRef = useRef({})
  const [loading, setLoading] = useState(false)
  const [submitForm, setSubmitForm] = useState<any>({})
  const [editFormItem, setEditFormItem] = useState<any>([])
  const [isEdit, setIsEdit] = useState(false)
  const [state, setState] = useSetState<any>({
    stateObj: {
      sale_stage: '营销阶段',
      design_stage: '设计阶段',
      pm_stage: '交付阶段',
    },
    formItemData: {},
  })

  // 表单权限：
  // 设计部经理	subsidiary_designMnr
  // 设计师	subsidiary_designer
  // 软装设计经理	subsidiary_softDesignMnr
  // 软装设计师	subsidiary_softDesign
  // 定制设计经理	subsidiary_tailorMadeDesignMnr
  // 定制设计师	subsidiary_tailorMadeDesign
  // 深化设计师	subsidiary_deepeningDesigner
  // 厨衣柜设计师	subsidiary_cabinetWardrobeDesign
  // 业绩设计师	subsidiary_achievementDesign
  // 橱柜设计师	subsidiary_chuGuiWardrobeDesign
  const hasAuth =
    auths['subsidiary_designMnr'] ||
    auths['subsidiary_designer'] ||
    auths['subsidiary_softDesignMnr'] ||
    auths['subsidiary_softDesign'] ||
    auths['subsidiary_tailorMadeDesignMnr'] ||
    auths['subsidiary_tailorMadeDesign'] ||
    auths['subsidiary_deepeningDesigner'] ||
    auths['subsidiary_cabinetWardrobeDesign'] ||
    auths['subsidiary_achievementDesign'] ||
    auths['subsidiary_chuGuiWardrobeDesign']

  useEffect(() => {
    initFn()
  }, [detail])

  useEffect(() => {
    submitFormValueRef.current = submitForm
  }, [submitForm])

  const initList: any = async () => {
    return new Promise((resolve, reject) => {
      try {
        getTrackPlanRelativesList({
          data: { stage: 'DESIGN', clueId: detail?.clueId },
        })
          .then(resp => {
            const obj = {}
            const newData = resp.reduce((res, item) => {
              if (!obj[item.ucenterUserId]) {
                obj[item.ucenterUserId] = true
                res.push(item)
              }
              return res
            }, [])
            let hasCreatedBy = newData?.find(item => item.ucenterUserId === detail?.createdBy)
            resolve({
              trackPlanRelativesList: newData || [],
              orderTakerList: hasCreatedBy
                ? newData
                : [
                    ...newData,
                    {
                      ucenterUserId: detail?.createdBy,
                      name: detail?.createdByName,
                    },
                  ],
            })
          })
          .catch(() => {
            resolve({ trackPlanRelativesList: [], orderTakerList: [] })
          })
      } catch (e) {
        reject({ trackPlanRelativesList: [], orderTakerList: [] })
      }
    })
  }

  const getOrderServicePersonnel = () => {
    orderServicePersonnel(id).then(res => {
      setState({ formItemData: res })
      setLoading(false)
    })
  }

  const initFn: any = async () => {
    if (loading) return
    setLoading(true)
    // 获取表单数组 渲染表单
    getOrderServicePersonnel()
  }

  const onFinishFn = () => {
    if (loading) return
    if (isEmpty(submitFormValueRef.current)) {
      setIsEdit(false)
      return
    }
    setLoading(true)
    const data: any[] = []
    Object.keys(submitFormValueRef.current).forEach(key => {
      const obj = {
        type: key,
        source: 'sale',
        servicesStage: 'sale_stage',
        customerType: 'serviceWorkerIn',
        ucenterId: submitFormValueRef.current[key] || '',
      }
      data.push(obj)
    })
    orderServicePersonnelUpdate(id, data)
      .then(res => {
        message.success(res?.message || '操作成功')
        setIsEdit(false)
        initFn(false)
        setSubmitForm({})
        setLoading(false)
      })
      .catch(() => {
        setIsEdit(false)
        setLoading(false)
      })
  }

  const clickToEdit = () => {
    const formItems = state.formItemData['design_stage']?.map(item => {
      return {
        spanCol: 12,
        label: item.typeName + '：',
        name: item.type,
        type: 'select',
        data: item.type === 'ORDER_TAKER' ? 'orderTakerList' : 'trackPlanRelativesList',
        comConfig: {
          defaultValue: item.ucenterId,
          disabled: !auths[item.type?.replace('.', '_')],
          fieldNames: { value: 'ucenterUserId', label: 'name' },
        },
      }
    })
    setEditFormItem(formItems)
    setIsEdit(true)
  }

  const handleFormItems = useMemo(() => {
    const config: any[] = []
    const keys = Object.keys(state.formItemData)
    keys?.forEach(key => {
      const formItem = state.formItemData[key]?.map(item => {
        const newItem: Record<string, any> = {
          spanCol: 8,
          label: item.typeName + '：',
          name: item.type,
          itemProps: {
            labelAlign: 'left',
            labelWrap: true,
            labelCol: { span: 'auto' },
          },
        }
        newItem.children = <div style={{ color: '#999' }}>{item.ucenterName}</div>
        return newItem
      })

      const item = {
        title:
          key === 'design_stage' && hasAuth ? (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {state.stateObj[key]}{' '}
              {formItem?.length > 0 ? (
                <Button type="primary" onClick={clickToEdit}>
                  {' '}
                  修改{' '}
                </Button>
              ) : (
                ''
              )}
            </div>
          ) : (
            state.stateObj[key]
          ),
        formItem,
        allowEdit: key === 'design_stage',
      }
      state.formItemData[key]?.length && config.push(item)
    })
    return config
  }, [state.formItemData])

  return (
    <Spin spinning={loading}>
      <div style={{ padding: '15px 20px' }} className={styles.servicesPersonForm}>
        {handleFormItems?.length > 0 ? (
          <SGeneralForms
            configs={handleFormItems}
            // layout={'vertical'}
            ref={formRef}
            isFooterBtn={true}
            // btnGroupNode={orderRelativesList?.length > 0 && hasAuth ? btnGroupNodeEdite() : []}
            isHideSubmitBtn={true}
            isHideGobackBtn={true}
            isHideResetBtn={true}
            // footerAlign="left"
          />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}

        <SDrawerOrModal
          title={'修改设计阶段服务人员'}
          open={isEdit}
          onCancel={() => setIsEdit(false)}
          onOk={onFinishFn}
          loading={loading}
        >
          <SGeneralForms
            layout={'vertical'}
            httpOptionsFn={initList}
            formConfig={{
              onValuesChange: e => {
                setSubmitForm({
                  ...submitForm,
                  ...e,
                })
              },
            }}
            configs={[{ formItem: editFormItem }]}
          />
        </SDrawerOrModal>
      </div>
    </Spin>
  )
}

export default props => {
  return <QuotaList {...props} />
}
